import { HttpService } from '@/data/http/http-service';

import { OpenRouteServiceGetDirectionsSchema } from './openrouteservice-api.dto';

const httpProject = new HttpService({
  baseURL: import.meta.env.VITE_API_PROJECT,
});

export async function fetchOpenRouteServiceApiToGetDistance(
  start: { lat: number; lon: number },
  end: { lat: number; lon: number },
): Promise<number> {
  try {
    const url = 'geo-position/get-driving-directions';
    const data = { start, end };
    const response = await httpProject.post(url, data);
    const parsedResponse = OpenRouteServiceGetDirectionsSchema.parse(
      response.data,
    );
    const distanceMeters =
      parsedResponse.features[0].properties.segments[0].distance;
    const distanceKm = Math.round(distanceMeters / 1000);
    return distanceKm;
  } catch (error) {
    console.error('error fetching road distance', error);
    return 0;
  }
}
